import React from 'react';
import "./style.css";

const Checkbox = props => {
  const {
    onChange,
    disabled,
    value,
    label,
    onFocus,
    onBlur
  } = props;
  let classText = 'checkbox__wrapper';

  if (disabled) {
    classText = 'checkbox__wrapper--disabled';
  }

  return /*#__PURE__*/React.createElement("label", {
    className: classText
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "checkbox",
    disabled: disabled,
    checked: value,
    onChange: e => onChange && onChange(e.target.checked),
    onBlur: onBlur,
    onFocus: onFocus
  }), label);
};

export default Checkbox;